import React from "react";
import Nav from "./Nav";
import "../scss/layout/Header.scss";

function Header () {
    return (
        <div className="header_container">
            <header className="header main_header">
                <h1 className="logo">Lotnictwo</h1>
                <input type="checkbox" className="fas fa-bars" />
                <Nav/>
            </header>
        </div>
    );
}

export default Header;